export default "__VITE_ASSET__DxJ_VWlR__"